<template>
  <div v-if="!this.$store.state.general.user.verified">
    <plans 
      msgtitle="You currently do not have access to Segmentation"
      msgdescription="Please choose a plan to pay to enjoy the Segmentation feature">
    </plans>
  </div>
  <div v-else>
    <div class="animated fadeIn m-3">
      <b-row>
        <div v-if="$isMobile()">
          <a v-b-toggle.toggle-analytics class="ml-3" variant="primary" size="sm" 
            style="text-decoration: none; color: #20a8d8">
            Show / Hide Summary Information
          </a>
          <b-collapse id="toggle-analytics" class="mt-2">
            <b-col :cols="12" :md="3">
              <b-card-group deck>
                <b-card footer-tag="footer">
                  <b-row>
                    <b-col :cols="12" class="text-center">
                      <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(files.length)}}</h1>
                    </b-col>
                  </b-row>
                  <template v-slot:footer>
                    <h6 class="mb-0 text-center" id="file-count">FILES</h6>
                  </template>
                </b-card>
              </b-card-group>
            </b-col>
            <b-col :cols="12" :md="3">
              <b-card-group deck>
                <b-card footer-tag="footer">
                  <b-row>
                    <b-col :cols="12" class="text-center">
                      <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(segments.length)}}</h1>
                    </b-col>
                  </b-row>
                  <template v-slot:footer>
                    <h6 class="mb-0 text-center" id="segment-count">SEGMENTS</h6>
                  </template>
                </b-card>
              </b-card-group>
            </b-col>
            <b-col :cols="12" :md="3">
              <b-card-group deck>
                <b-card footer-tag="footer">
                  <b-row>
                    <b-col :cols="12" class="text-center">
                      <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(referralInfo.conversion)}}</h1>
                    </b-col>
                  </b-row>
                  <template v-slot:footer>
                    <h6 class="mb-0 text-center" :id="referralInfo.conversion">CONVERSIONS (PAID)</h6>
                  </template>
                </b-card>
              </b-card-group>
            </b-col>
            <b-col :cols="12" :md="3">
              <b-card-group deck>
                <b-card footer-tag="footer">
                  <b-row>
                    <b-col :cols="12" class="text-center">
                      <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(referralInfo.points)}}</h1>
                    </b-col>
                  </b-row>
                  <template v-slot:footer>
                    <h6 class="mb-0 text-center" :id="referralInfo.points">POINTS</h6>
                  </template>
                </b-card>
              </b-card-group>
            </b-col>
          </b-collapse>
        </div>
        <b-col v-if="!$isMobile()" :cols="12" :md="3">
          <b-card-group deck>
            <b-card footer-tag="footer">
              <b-row>
                <b-col :cols="12" class="text-center">
                  <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(files.length)}}</h1>
                </b-col>
              </b-row>
              <template v-slot:footer>
                <h6 class="mb-0 text-center" id="file-count">FILES</h6>
              </template>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col v-if="!$isMobile()" :cols="4" :md="3">
          <b-card-group deck>
            <b-card footer-tag="footer">
              <b-row>
                <b-col :cols="12" class="text-center">
                  <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(segments.length)}}</h1>
                </b-col>
              </b-row>
              <template v-slot:footer>
                <h6 class="mb-0 text-center" id="segment-count">SEGMENTS</h6>
              </template>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col v-if="!$isMobile()" :cols="4" :md="3">
          <b-card-group deck>
            <b-card footer-tag="footer">
              <b-row>
                <b-col :cols="12" class="text-center">
                  <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(referralInfo.conversion)}}</h1>
                </b-col>
              </b-row>
              <template v-slot:footer>
                <h6 class="mb-0 text-center" :id="referralInfo.conversion">CONVERSIONS (PAID)</h6>
              </template>
            </b-card>
          </b-card-group>
        </b-col>
        <b-col v-if="!$isMobile()" :cols="4" :md="3">
          <b-card-group deck>
            <b-card footer-tag="footer">
              <b-row>
                <b-col :cols="12" class="text-center">
                  <h1 style="font-size: 35px; color: #20A8D8">{{abbreviateNumber(referralInfo.points)}}</h1>
                </b-col>
              </b-row>
              <template v-slot:footer>
                <h6 class="mb-0 text-center" :id="referralInfo.points">POINTS</h6>
              </template>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <div class="animated fadeIn m-3">
      <b-row>
        <b-col :cols="12" :md="12">
          <b-card>
            <b-row>
              <b-col>
                <div class="mb-2" style="font-size: larger">
                  <h3 class="m-0 text-center">Welcome to <span style="color: #20A8D8">Superfluid.io Platform</span></h3>
                  <hr/>
                  <p>Welcome to the Superfluid.io platform! We are super excited to have you onboard.</p>
                  <p>Here are 3 steps to help you get started and grow your business with insights from your data</p>
                  
                  <!-- STEP 1 -->
                  <div class="mt-3 mb-3" style="line-height: 2rem">
                    <span style="color: #60C8FF">1. Create your first project and upload your data</span><br/>
                    Projects are a way of organizing files to work on. They help users to map out their data and use a single file for multiple analytic works as well as helping users collaborate.<br/>
                    <b-button
                      size="md"
                      variant="primary"
                      @click="createProject()">
                      Create Project
                    </b-button>
                  </div>
                  
                  <!-- STEP 2 -->
                  <div class="mt-3 mb-3" style="line-height: 2rem">
                    <span style="color: #60C8FF">2. Map your data</span><br/>
                    Mapping your columns helps us understand your data before our powerful platform generates useful insights for you<br/>
                  </div>
                  
                  <!-- STEP 3 -->
                  <div class="mt-3 mb-3" style="line-height: 2rem">
                    <span style="color: #60C8FF">3. Get your first insights</span><br/>
                    Get different interactive business reports from the data and a lot more custom reports<br/>
                  </div>

                  <hr/>
                  <div class="mt-3 mb-3" style="line-height: 2rem">
                    <span style="color: #60C8FF">Learn more from our video tutorials</span><br/>
                    
                    <b-row v-if="youTubeVideoKeys">
                      <b-col :cols="12" :md="6" v-for="key in youTubeVideoKeys" :key="key">
                        <iframe v-if="$isMobile()" width="100%" height="180" :src="`https://www.youtube.com/embed/` + key" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        
                        <iframe v-else width="100%" height="320" :src="`https://www.youtube.com/embed/` + key" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-row>
              <b-col>
                <div class="mb-2">
                  <h5 class="m-0">Refer Superfluid Platform and get rewarded</h5>
                  <div>Grab your chance now!!</div>
                  
                  <hr/>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col :cols="12" :md=6>
                <b-row>
                  <b-col :cols="12" :md=3>
                    <label for="referral-link">
                      <h6 >Referral Link:</h6>
                    </label>
                  </b-col>
                  <b-col :cols="12" :md=9>
                    <b-form-input 
                      id="referral-link" 
                      size="md" 
                      v-model="refURL"
                      disabled="" 
                      style="color:#aaa"
                      :placeholder="refURL">
                    </b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col :cols="12" :md=6>
                <b-row class="mt-2">
                  <b-col :cols="6" :md=3>
                    <b-button
                      size="md" 
                      variant="primary"  
                      type="button"
                      v-clipboard:copy="refURL"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError">
                      <i class="fa fa-copy"></i> Copy
                    </b-button>
                  </b-col>
                  <b-col :cols="6" :md=9>
                    <a :href="`https://www.facebook.com/sharer/sharer.php?u=` + refURL" target="_blank">
                      <i class="fa fa-facebook-official" style="font-size: 2.3rem"></i>
                    </a>&nbsp;&nbsp;&nbsp;
                    <a :href="`http://twitter.com/share?text=` + refURL" target="_blank">
                      <i class="fa fa-twitter" style="font-size: 2.3rem"></i>
                    </a>&nbsp;&nbsp;&nbsp;
                    <a :href="`whatsapp://send?text=` + refURL" data-action="share/whatsapp/share" target="_blank">
                      <i class="fa fa-whatsapp" style="font-size: 2.3rem"></i>
                    </a>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col v-show="false" :cols="12" :md="3">
          <b-card>

          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import {fullURL} from '../../utils';

  export default {
    name: 'Home',

    data() {
      const files = this.$store.state.files.fileList;
      const segments = this.$store.state.segments.segmentList;
      const videos = this.$store.state.general.video_tutorials;

      return {
        files: files,
        segments: segments,
        videos: videos,
        refCode: '',
        refURL: '',
        loading: true,
      };
    },

    mounted() {
      this.loading = false;
      this.refCode = this.referralInfo.code;
      this.refURL = this.referralInfo.info_url;
    },

    computed: {
      referralInfo() {
        var info = {};
        var user = this.$store.state.general.user;
        info['code'] = user.referral_code;
        info['info_url'] = user.info_url;
        info['url'] = user.referral_url;
        info['count'] = user.num_of_signup || 0;
        info['conversion'] = user.num_of_conversion || 0;
        info['points'] = user.points || 0;
        return info;
      },

      youTubeVideoKeys() {
        var keys = [];
        this.videos.slice(0, 4).forEach(video => {
          var key = '';
          if (video.url.indexOf('youtube') > -1) {
            keys.push(video.url.split("v=")[1]);
          }
          else if (video.url.indexOf('youtu.be') > -1) {
            keys.push(video.url.split(".be/")[1]);
          }
        });
        return keys;
      }
    },

    watch: {
      
    },

    methods: {
      abbreviateNumber(number) {
        var SI_SYMBOL = ["", "k", "M", "B", "T", "P", "E"];
        var tier = Math.log10(number) / 3 | 0;
        if(tier == 0) {
          if (number % 1 !== 0) {
            return round(number)
          }
          return number;
        }
        var suffix = SI_SYMBOL[tier];
        var scale = Math.pow(10, tier * 3);
        var scaled = number / scale;
        return scaled.toFixed(1) + suffix;
      },

      onCopy: function (e) {
        // alert('You just copied: ' + e.text);
        this.$bvToast.toast('Referral link copied!', {
          title: 'Successful',
          autoHideDelay: 500,
          variant: 'success',
          solid: true
        });
      },

      onCodeCopy: function (e) {
        this.$bvToast.toast('Referral code copied!', {
          title: 'Successful',
          autoHideDelay: 500,
          variant: 'success',
          solid: true
        });
      },

      onError: function (e) {
        // alert('Failed to copy texts');
      },

      createProject() {
        this.$router.push(`/sources`);
      }
    }
  };
</script>
